(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chery-native-last-chance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cs-native-last-chance')) {
    customElements.define('cs-native-last-chance', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.addEventListener('click', event => {
          if (event.target.closest('[data-cs-native-close]')) this.closeInfo(true);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          event.stopPropagation();
          this.closeInfo(true);
        }, options);
        this.addEventListener('keyup', event => {
          if (event.key === 'Escape') event.stopPropagation();
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeInfo(false);
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      closeInfo(restoreFocus) {
        const details = this.querySelector('details');
        if (!details?.open) return;
        details.open = false;
        if (restoreFocus) details.querySelector('summary').focus({preventScroll:true});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
